import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class DeleteDataAlertsRequest extends Request<IMultipleIdsParams, IResult> {
  constructor(ids: string[]) {
    super('deleteDataAlerts', { ids: ids });
  }
}
